import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItemsLinkedToCodeLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItemsLinkedToCodeLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingNotesWithRecordingsLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingNotesWithRecordingsLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goalsLinkedToWorkLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goalsLinkedToWorkLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentsConnectedToServicesLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentsConnectedToServicesLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.connectedAppsHighlight.heading',
		defaultMessage: 'Graph connectivity',
		description: 'Section heading above the connected-apps statistics',
	},
	workItemsLinkedToCodeLine1: {
		id: 'twg-microsite.connectedAppsHighlight.workItemsLinkedToCode.line1',
		defaultMessage: 'OF WORK ITEMS ARE',
		description: 'First line of the label for the percentage of work items linked to code changes',
	},
	workItemsLinkedToCodeLine2: {
		id: 'twg-microsite.connectedAppsHighlight.workItemsLinkedToCode.line2',
		defaultMessage: 'LINKED TO CODE CHANGES',
		description: 'Second line of the label for the percentage of work items linked to code changes',
	},
	meetingNotesWithRecordingsLine1: {
		id: 'twg-microsite.connectedAppsHighlight.meetingNotesWithRecordings.line1',
		defaultMessage: 'MEETING NOTES WITH',
		description:
			'First line of the label for the percentage of meeting notes with linked recordings',
	},
	meetingNotesWithRecordingsLine2: {
		id: 'twg-microsite.connectedAppsHighlight.meetingNotesWithRecordings.line2',
		defaultMessage: 'LINKED RECORDINGS',
		description:
			'Second line of the label for the percentage of meeting notes with linked recordings',
	},
	goalsLinkedToWorkLine1: {
		id: 'twg-microsite.connectedAppsHighlight.goalsLinkedToWork.line1',
		defaultMessage: 'GOALS ARE LINKED',
		description: 'First line of the label for the percentage of goals linked to downstream work',
	},
	goalsLinkedToWorkLine2: {
		id: 'twg-microsite.connectedAppsHighlight.goalsLinkedToWork.line2',
		defaultMessage: 'TO DOWNSTREAM WORK',
		description: 'Second line of the label for the percentage of goals linked to downstream work',
	},
	incidentsConnectedToServicesLine1: {
		id: 'twg-microsite.connectedAppsHighlight.incidentsConnectedToServices.line1',
		defaultMessage: 'INCIDENTS CONNECTED',
		description: 'First line of the label for the percentage of incidents connected to services',
	},
	incidentsConnectedToServicesLine2: {
		id: 'twg-microsite.connectedAppsHighlight.incidentsConnectedToServices.line2',
		defaultMessage: 'TO SERVICES',
		description: 'Second line of the label for the percentage of incidents connected to services',
	},
});
